import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { MdAdd } from 'react-icons/md';
import { useTranslations } from 'next-intl';
interface PropTypes {
  onClick?: (event?: React.MouseEvent<HTMLHeadingElement | HTMLButtonElement>) => void;
  className?: string;
}
function CreateListButton(t0) {
  const $ = _c(9);
  const {
    onClick,
    className
  } = t0;
  const t = useTranslations();
  const t1 = `flex flex-row items-center h-[40px] rounded-md px-4 bg-black hover:opacity-[0.6] ${className}`;
  let t2;
  if ($[0] !== t) {
    t2 = t("components.create_list_button.text");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="text-white text-sm font-bold mr-2">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MdAdd className="text-white" size={18} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onClick || $[6] !== t1 || $[7] !== t3) {
    t5 = <button className={t1} onClick={onClick}>{t3}{t4}</button>;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default CreateListButton;